import request from '@/utils/request';

const PATH = '/region';

export const getRegionList = () => request({
  url: PATH,
  method: 'get',
});
